import React from "react";

import Percentage from "features/classroom/common/Percentage";

import styles from "./SectionRowPercentage.module.scss";

type Props = {
  value: number | null | undefined;
};

export default function SectionRowPercentage({ value }: Props) {
  return (
    <span className={styles.percentage}>
      <Percentage value={value} />
    </span>
  );
}
